import { ReactNode, ComponentType, ElementType } from 'react';

// 아이콘 타입 정의 (react-icons, lucide-react 모두 지원)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type IconComponent = ElementType<any>;

// 단일 메뉴 아이템
export interface NavigationMenuItem {
  id: string;
  label: string;
  icon: IconComponent;
  path?: string;
  menuAuthKey?: string; // 권한 체크할 키
  checkAuth?: boolean; // 이 아이템만 권한 체크할지 여부
  disabled?: boolean;
  onClick?: () => void;
}

// 서브메뉴를 가진 메뉴 아이템
export interface NavigationSubMenu {
  id: string;
  label: string;
  icon: IconComponent;
  items: NavigationMenuItem[];
  menuAuthKey?: string;
}

// 메뉴 아이템 유니온 타입
export type NavigationMenuItemType = NavigationMenuItem | NavigationSubMenu;

// 서브메뉴인지 확인하는 타입 가드
export const isSubMenu = (item: NavigationMenuItemType): item is NavigationSubMenu => {
  return 'items' in item && Array.isArray(item.items);
};

// 메뉴 설정
export interface NavigationMenuConfig {
  items: NavigationMenuItemType[];
  supportEmail?: string;
  supportGuideUrl?: string;
}

// 네비게이션 전체 설정
export interface NavigationConfig {
  menuConfig: NavigationMenuConfig;
  getActivePath: (pathname: string) => string | null;
  getPath: (menuId: string) => string;
  
  // 권한 체크 관련 - 모두 optional
  enableAuthCheck?: boolean;
  checkMenuAuth?: (menuAuthKey: string, menuAuth?: string[]) => boolean;
  
  // 커스텀 액션 (딜플로우, 포트폴리오 등 특별한 로직이 필요한 경우)
  onMenuClick?: (menuId: string) => void;
}

// 레이아웃 Props
export interface LayoutProps {
  children: ReactNode;
  navigationConfig: NavigationConfig;
  showNavigation?: boolean;
  showHeader?: boolean;
  isFullScreen?: boolean;
  isOnboardingMode?: boolean;
  OnboardingNavigation?: ComponentType<{
    isOpen: boolean;
    toggleNav: () => void;
  }>;
  /** SpaceNavigation 아래에 표시될 커스텀 컴포넌트 (펼친 상태) */
  customComponent?: ReactNode;
  /** SpaceNavigation 아래에 표시될 커스텀 컴포넌트 (접힌 상태) */
  customComponentCollapsed?: ReactNode;
}

// Navigation Props
export interface NavigationProps {
  isOpen: boolean;
  toggleNav: () => void;
  config: NavigationConfig;
  /** SpaceNavigation 아래에 표시될 커스텀 컴포넌트 (펼친 상태) */
  customComponent?: ReactNode;
  /** SpaceNavigation 아래에 표시될 커스텀 컴포넌트 (접힌 상태) */
  customComponentCollapsed?: ReactNode;
}

// Header Props
export interface HeaderProps {
  // 필요시 추가
}

// NavHeader Props
export interface NavHeaderProps {
  isCollapsed?: boolean;
  onToggle?: () => void;
}

// SpaceNavigation Props
export interface SpaceNavigationProps {
  isCollapsed?: boolean;
}

